<div class="login-page d-flex flex-column flex-root" id="kt_app_root">
  <div class="d-flex flex-column flex-lg-row flex-column-fluid min-vh-100">
    <div
      class="d-flex flex-column flex-lg-row-fluid w-lg-50 p-10 order-2 order-lg-1"
    >
      <div class="d-flex flex-center flex-column flex-lg-row-fluid">
        <div class="w-lg-500px p-10">
          <div class="text-center mb-11">
            <h1 class="text-gray-900 fw-bolder mb-3" style="font-size: 2.25rem">
              {{ "welcomeText" | translate }}
            </h1>
            <div class="text-gray-500 fw-semibold" style="font-size: 1.25rem">
              {{ "descriptionText" | translate }}
            </div>
          </div>

          <form
            *ngIf="
              !showFirstLogin &&
              !show2FA &&
              !showMailSection &&
              !showLoginWithMail &&
              !showLoginWithGoogle &&
              !showGoogleSection
            "
            [formGroup]="loginForm"
            (submit)="submitLogin($event)"
            class="form w-100"
          >
            <div class="fv-row mb-8">
              <input
                type="text"
                formControlName="email"
                [placeholder]="'email' | translate"
                class="form-control bg-transparent"
                [ngClass]="{
                  'is-invalid':
                    loginForm.get('email')?.invalid &&
                    loginForm.get('email')?.touched
                }"
              />
            </div>

            <div class="fv-row mb-3 position-relative">
              <input
                [type]="loginPasswordVisible ? 'text' : 'password'"
                formControlName="password"
                [placeholder]="'profile.password' | translate"
                class="form-control bg-transparent"
                [ngClass]="{
                  'is-invalid':
                    loginForm.get('password')?.invalid &&
                    loginForm.get('password')?.touched
                }"
              />

              <span
                *ngIf="loginForm.get('password')?.value"
                class="btn btn-sm btn-icon position-absolute translate-middle top-50 end-0 me-n2"
                (click)="togglePasswordVisibility('login')"
                style="z-index: 10"
              >
                <i
                  class="fa-solid"
                  [ngClass]="loginPasswordVisible ? 'fa-eye' : 'fa-eye-slash'"
                ></i>
              </span>
            </div>

            <div class="d-flex flex-stack flex-wrap fs-base fw-semibold mb-3">
              <div class="form-check form-check-custom form-check-solid">
                <input
                  class="form-check-input cursor-pointer"
                  type="checkbox"
                  formControlName="rememberMe"
                  id="rememberMeCheck"
                />
                <label
                  class="form-check-label text-gray-500 cursor-pointer"
                  for="rememberMeCheck"
                >
                  {{ "rememberMe" | translate }}
                </label>
              </div>
            </div>

            <div class="d-grid mb-10">
              <button
                type="submit"
                class="btn btn-primary cursor-pointer"
                [disabled]="loading"
              >
                <span class="indicator-label">
                  <ng-container *ngIf="loading; else showLoginText">
                    {{ "pleaseWait" | translate }}
                    <span
                      class="spinner-border spinner-border-sm align-middle ms-2"
                    ></span>
                  </ng-container>
                  <ng-template #showLoginText>{{
                    "login" | translate
                  }}</ng-template>
                </span>
              </button>
            </div>
          </form>

          <form
            *ngIf="showFirstLogin && !show2FA"
            [formGroup]="firstLoginForm"
            (submit)="submitFirstLogin($event)"
            class="form w-100"
          >
            <div class="fw-semibold fs-4 mt-4">
              {{ "firstLogin" | translate }}
            </div>
            <div class="row">
              <div class="col-md-12 mt-4">
                <div class="form-floating">
                  <input
                    class="form-control"
                    id="inputNewPassword"
                    type="password"
                    formControlName="password"
                    placeholder="New password"
                  />
                  <label for="inputNewPassword">{{
                    "newPassword" | translate
                  }}</label>
                </div>
              </div>
              <div class="col-md-12 mt-4">
                <div class="form-floating">
                  <input
                    class="form-control"
                    id="inputNewConfirmPassword"
                    type="password"
                    formControlName="confirmPassword"
                    placeholder="Confirm Password"
                  />
                  <label for="inputNewConfirmPassword">{{
                    "confirmPassword" | translate
                  }}</label>
                </div>
              </div>
            </div>
            <div class="d-grid mb-10 mt-6">
              <button
                type="submit"
                class="btn btn-primary cursor-pointer"
                [disabled]="loading"
              >
                <span class="indicator-label">
                  <ng-container *ngIf="loading; else showSubmitText">
                    {{ "pleaseWait" | translate }}
                    <span
                      class="spinner-border spinner-border-sm align-middle ms-2"
                    ></span>
                  </ng-container>
                  <ng-template #showSubmitText>{{
                    "submit" | translate
                  }}</ng-template>
                </span>
              </button>
            </div>
          </form>

          <form
            *ngIf="showMailSection"
            [formGroup]="mailCodeForm"
            (submit)="submitMailAuthCode($event)"
            class="form w-100"
          >
            <div class="fw-semibold fs-4 mt-4">
              {{ "emailAuthentication" | translate }}
            </div>
            <div class="row">
              <div class="col-md-12 mt-4">
                <div class="form-floating">
                  <input
                    class="form-control"
                    formControlName="code"
                    id="inputCode"
                    type="text"
                    placeholder="Code"
                  />
                  <label for="inputCode">{{ "code" | translate }}</label>
                </div>
              </div>
            </div>
            <div class="d-grid mb-10 mt-6">
              <button type="submit" class="btn btn-primary cursor-pointer">
                <span class="indicator-label">{{ "submit" | translate }}</span>
              </button>
            </div>
          </form>

          <form
            *ngIf="showGoogleSection"
            [formGroup]="googleCodeForm"
            (submit)="submitGoogleAuthCode($event)"
            class="form w-100"
          >
            <div class="fw-semibold fs-4 mt-4">
              {{ "googleAuthentication" | translate }}
            </div>
            <div class="row">
              <div class="col-md-12 mt-4">
                <div class="form-floating">
                  <input
                    class="form-control"
                    formControlName="code"
                    id="inputGoogleCode"
                    type="text"
                    placeholder="Code"
                    [ngClass]="{
                        'is-invalid':
                        googleCodeForm.get('code')?.invalid &&
                        googleCodeForm.get('code')?.touched
                    }"
                  />
                  <label for="inputGoogleCode">{{ "code" | translate }}</label>
                </div>
              </div>
            </div>
            <div class="d-grid mb-10 mt-6">
              <button 
                type="submit" 
                class="btn btn-primary cursor-pointer"
                [disabled]="loading"
              >
                <span class="indicator-label">
                  <ng-container *ngIf="loading; else showSubmitText">
                    {{ "pleaseWait" | translate }}
                    <span class="spinner-border spinner-border-sm align-middle ms-2"></span>
                  </ng-container>
                  <ng-template #showSubmitText>{{ "submit" | translate }}</ng-template>
                </span>
              </button>
            </div>
          </form>

          <div
            class="d-flex align-items-center justify-content-between mt-4"
            style="position: relative; top: -7px"
          >
            <div class="me-11 cursor-pointer">
              <button
                class="btn btn-flex btn-link btn-color-gray-700 btn-active-color-primary rotate fs-base"
                data-kt-menu-trigger="click"
                data-kt-menu-placement="bottom-start"
                data-kt-menu-offset="0px, 0px"
              >
                <img
                  *ngIf="currentLanguageFlag"
                  class="rounded me-3 h-20px w-20px"
                  [src]="currentLanguageFlag"
                  loading="lazy"
                  width="20"
                  height="20"
                />
                <span class="me-1">{{ currentLanguageName }}</span>
                <span class="d-flex flex-center rotate-180">
                  <i class="fa-solid fa-chevron-down text-muted"></i>
                </span>
              </button>

              <div
                class="menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-800 menu-state-bg-light-primary fw-semibold w-200px py-4 fs-7"
                data-kt-menu="true"
                id="kt_auth_lang_menu"
              >
                <div class="menu-item px-3" *ngFor="let lang of languages">
                  <a class="menu-link d-flex px-5" (click)="setLanguage(lang)">
                    <span class="symbol symbol-20px me-4">
                      <img class="rounded-1" [src]="lang.flag" />
                    </span>
                    <span>{{ lang.name }}</span>
                  </a>
                </div>
              </div>
            </div>
            <a class="forgot-password" routerLink="/forgot-password">
              {{ "loginForgotPassword" | translate }}
            </a>
          </div>
        </div>
      </div>
    </div>

    <div
      class="d-flex flex-lg-row-fluid w-lg-50 bgi-size-cover bgi-position-center order-1 order-lg-2"
      style="background-image: url(assets/media/misc/auth-bg.png)"
    >
      <app-welcome-image class="w-100"></app-welcome-image>
    </div>
  </div>
</div>